<p>{{ "customer-verification.account-created-short" | translate }}</p>
<p>
	{{
		(hasBonus ? "customer-verification.choose-bonus-to-play" : "customer-verification.deposit-to-play") | translate
	}}
</p>
